import { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import '../styles.css';
import { setLocalStorage } from '../../../../utils';
import {
  useIsReadyFile,
  useShowStepsUploading,
  useStepsNumberLoader
} from '../../../../lib/store/dashboard.store';
import { UploadLoader } from '../../../Layout/app/frame/shared/loader-upload';

const steps = [
  {
    id: 1,
    label:
      '<div class="flex flex-col items-center gap-0.5 -ml-3"><span>Ingesting</span> <span>file</span></div>',
    duration: 3000
  },
  {
    id: 2,
    label:
      '<div class="flex flex-col items-center gap-0.5 -ml-2"><span>Inspecting</span> <span>variables</span></div>',
    duration: 3000
  },
  {
    id: 3,
    label:
      '<div class="flex flex-col items-center gap-0.5 -ml-2"><span>Generating</span> <span>metadata</span></div>',
    duration: 3000
  },
  {
    id: 4,
    label:
      '<div class="flex flex-col items-center gap-0.5 -ml-1"><span>Running</span> <span>analysis</span></div>',
    duration: 3000
  },
  {
    id: 5,
    label:
      '<div class="flex flex-col items-center gap-0.5 -ml-2.5"><span>Encoding</span> <span>results</span></div>',
    duration: 3000
  },
  {
    id: 6,
    label:
      '<div class="flex flex-col items-center -ml-2"><span class"">Done</span> <span class="invisible">results</span></div>',
    duration: 100
  }
];

export const UploadStepsSpinningWheel = () => {
  const currentStep = useStepsNumberLoader((state: any) => state.step);
  const setCurrentStep = useStepsNumberLoader((state: any) => state.setStep);
  const showSteps = useShowStepsUploading((state: any) => state.showSteps);
  const setShowSteps = useShowStepsUploading((state: any) => state.setShowSteps);
  const isReadyFile = useIsReadyFile((state: any) => state.isReady);
  const [textStatus, setTextStatus] = useState<string>('');
  const [showBlock, setShowBlock] = useState(false);

  useEffect(() => {
    if (currentStep < steps.length && showSteps) {
      if (currentStep == 3 && !isReadyFile) {
        return;
      }
      const timer = setTimeout(() => {
        setLocalStorage('currentStep', currentStep + 1);
        setCurrentStep(currentStep + 1);
      }, steps[currentStep].duration);
      if (currentStep == steps.length - 1) {
        resetSteps();
      }
      return () => clearTimeout(timer);
    }
  }, [currentStep, showSteps, isReadyFile]);

  const resetSteps = () => {
    setLocalStorage('endUploadLoader', true);
  };

  useEffect(() => {
    if (!showSteps) {
      setTimeout(() => {
        setCurrentStep(0);
        setShowSteps(true);
      }, 600);
    }
  }, []);

  useEffect(() => {
    if (currentStep == 3) {
      setTimeout(() => {
        setTextStatus('Working on it...');
      }, 45000);
      setTimeout(() => {
        setTextStatus('Still working...');
      }, 90000);
      setTimeout(() => {
        setTextStatus('A bit more...');
      }, 135000);
      setTimeout(() => {
        setTextStatus('Nearly there...');
      }, 180000);
      setTimeout(() => {
        setTextStatus('Wrapping up...');
      }, 240000);
    }
  }, [currentStep]);

  useEffect(() => {
    setShowBlock(false);
    const timer = setTimeout(() => {
      setShowBlock(true);
    }, 500);
    return () => clearTimeout(timer);
  }, [currentStep]);

  return (
    <div className="p-4 font-montserrat">
      <div className={`steps-container ${showSteps ? 'show' : ''}`}>
        <ul className="flex flex-row justify-between px-4">
          {steps.map((step, index) => (
            <li
              key={index}
              className={`flex items-center mb-4 text-xs ${
                index == currentStep || (currentStep === 6 && index == 5)
                  ? 'text-[#364152] font-semibold'
                  : index < currentStep
                  ? 'text-[#364152]'
                  : 'text-[#3641524D]'
              } relative h-[164px]`}>
              <div className="flex flex-col items-center gap-4">
                <span>{ReactHtmlParser(step.label)}</span>
                <div className="relative flex items-center">
                  {currentStep == index ? (
                    <>
                      <span className="flex-shrink-0 z-[1000]">
                        {!showBlock && index > 0 ? (
                          <div
                            className={`flex-shrink-0 w-4 h-4 rounded-full border-[#DAE0E9] border-solid border-[1px] bg-[#fff] -ml-1.5 z-[1000]`}>
                            {' '}
                          </div>
                        ) : (
                          <UploadLoader />
                        )}

                        {index < steps.length - 1 && (
                          <div
                            className={`${
                              window.outerWidth <= 820 || window.innerWidth <= 820
                                ? 'w-[13vw]'
                                : step.id == 5
                                ? '2xl:w-[6.25vw] w-[5.75vw]'
                                : '2xl:w-[6.5vw] w-[6.75vw]'
                            } absolute z-[0] top-1/2 ml-3.5 transform -translate-y-1/2 h-[1px] border-t border-dashed border-[#DAE0E9]`}></div>
                        )}
                      </span>
                      <span className="text-xs light-black absolute mt-[72px] -ml-[54px] w-[120px] text-center text-[#1C8CA6]">
                        {textStatus}
                      </span>
                    </>
                  ) : (
                    <span
                      className={`flex-shrink-0 w-4 h-4 rounded-full border-[#DAE0E9] border-solid border-[1px] ${
                        index <= currentStep ? 'bg-[#2497B2CC]' : 'bg-[#fff]'
                      } mr-4 z-[1000] ${
                        currentStep === 6 && index == 5 ? 'flex items-center justify-center' : ''
                      } `}>
                      {' '}
                      {index < steps.length - 1 && (
                        <div
                          className={`${
                            window.outerWidth <= 820 || window.innerWidth <= 820
                              ? 'w-[18vw]'
                              : `${
                                  step.id == 5
                                    ? '2xl:w-[6.75vw] w-[7.5vw]'
                                    : '2xl:w-[7.25vw] w-[8.7vw]'
                                } `
                          } z-[0] absolute top-1/2 ml-3.5 transform -translate-y-1/2 h-[1px] ${
                            currentStep > index
                              ? 'border-solid border-[#2497B2] border-t-[1.5px] transition-width duration-500 ease-in-out delay-75'
                              : ' border-dashed border-[#DAE0E9] border-t'
                          } `}></div>
                      )}
                      {currentStep === 6 && index == 5 && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="white"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="w-3 h-3 z-[1000]">
                          <path d="M20 6L9 17l-5-5" />
                        </svg>
                      )}
                    </span>
                  )}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
